import React from "react";
import {
  Box,
  Button,
  Container,
  Flex,
  Heading,
  HStack,
  Text,
  VStack,
} from "@chakra-ui/react";
import { NavLink, Outlet } from "react-router-dom";
import { AUTH_PROVIDERS, useAuthProvider } from "../Authentication/AuthProviderSwitch";

const navItems = [
  { label: "Account", to: "/client/account" },
  { label: "Subscriptions", to: "/client/subscriptions" },
  { label: "Purchases", to: "/client/purchases" },
  { label: "Integrations", to: "/client/integrations" },
  { label: "Security", to: "/client/security" },
  { label: "Helpdesk", to: "/client/helpdesk" },
];

const ClientPortalLayout = () => {
  const { user, logout, provider } = useAuthProvider();

  const handleLogout = () => {
    if (!logout) return;
    if (provider === AUTH_PROVIDERS.AUTH0) {
      logout({ returnTo: window.location.origin });
      return;
    }
    logout();
  };

  return (
    <Box minH="100vh" bg="gray.50" py={10}>
      <Container maxW="container.xl">
        <VStack align="stretch" spacing={6}>
          <Flex justify="space-between" align="center" gap={4} wrap="wrap">
            <Box>
              <Heading size="lg">Client Portal</Heading>
              <Text color="gray.600">Manage company users, subscriptions, purchases, integrations, and support.</Text>
            </Box>
            <HStack spacing={3}>
              <Text color="gray.600" fontSize="sm">{user?.email || user?.name || "Client user"}</Text>
              <Button variant="outline" size="sm" onClick={handleLogout}>Sign out</Button>
            </HStack>
          </Flex>

          <Flex direction={{ base: "column", lg: "row" }} gap={6}>
            <Box
              w={{ base: "full", lg: "260px" }}
              bg="white"
              borderWidth="1px"
              borderColor="gray.200"
              borderRadius="lg"
              p={3}
              h="fit-content"
            >
              <VStack align="stretch" spacing={1}>
                {navItems.map((item) => (
                  <Box
                    as={NavLink}
                    key={item.to}
                    to={item.to}
                    px={3}
                    py={2}
                    borderRadius="md"
                    fontWeight="semibold"
                    color="gray.700"
                    _hover={{ bg: "gray.100" }}
                    _activeLink={{ bg: "blue.50", color: "blue.700" }}
                  >
                    {item.label}
                  </Box>
                ))}
              </VStack>
            </Box>

            <Box flex="1" bg="white" borderWidth="1px" borderColor="gray.200" borderRadius="lg" p={{ base: 4, md: 6 }}>
              <Outlet />
            </Box>
          </Flex>
        </VStack>
      </Container>
    </Box>
  );
};

export default ClientPortalLayout;
